/**
 * Серверные команды для UppyWidget.
 */
var AsyncServerCmd;
(function (AsyncServerCmd) {
    /** Процесс на сервере не найден */
    AsyncServerCmd["procDeleted"] = "procDeleted";
    /** Информация о статусе процесса */
    AsyncServerCmd["procStatus"] = "procStatus";
    /** Набор статусов */
    AsyncServerCmd["procBatch"] = "procBatch";
})(AsyncServerCmd || (AsyncServerCmd = {}));
/**
 * Статусы выполнения процесса (синхронизированы с C# AsyncProcessStatuses).
 */
var ProcStatus;
(function (ProcStatus) {
    /** Ожидает выполнения */
    ProcStatus[ProcStatus["Waiting"] = 0] = "Waiting";
    /** Выполняется */
    ProcStatus[ProcStatus["Working"] = 1] = "Working";
    /** Завершено успешно */
    ProcStatus[ProcStatus["Done"] = 2] = "Done";
    /** Завершено с ошибкой */
    ProcStatus[ProcStatus["Error"] = 3] = "Error";
    /** Прервано */
    ProcStatus[ProcStatus["Aborted"] = 4] = "Aborted";
})(ProcStatus || (ProcStatus = {}));

export { AsyncServerCmd, ProcStatus };
